module.exports = __webpack_public_path__ + "img/menu_ladies_diet.19cbcab2.png";